import { Component } from '@verndale/core';

class Module extends Component {
    setupDefaults() {
        this.dom = {
            $tabs: this.el.querySelectorAll('nav button[id^="tab-"]'),
            $select: this.el.querySelector('.tabbed-content__dropdown'),
            $navBar: this.el
        };

        this.updateActiveNavDebounced = this.debounce(this.updateActiveNav.bind(this), 50);
    }

    addListeners() {
        this.dom.$tabs.forEach($tab => {
            $tab.addEventListener('click', this.scrollToAnchor.bind(this));
        });

        this.dom.$select.addEventListener('change', this.scrollToAnchor.bind(this));
        document.addEventListener('scroll', this.updateActiveNavDebounced);
        window.addEventListener('load', this.updateActiveNav.bind(this));
    }

    scrollToAnchor(e) {
        let anchor;
        if (e.target.tagName === 'BUTTON') {
            anchor = e.target.getAttribute('aria-controls');
        } else if (e.target.tagName === 'SELECT') {
            anchor = e.target.value;
        }

        if (anchor) {
            const timelineGroup = document.getElementById(anchor);
            const mainPageHeaderHeight = 97; // use 0 for module, use 97 for template

            if (timelineGroup) {
                const navBarHeight = this.dom.$navBar.offsetHeight;
                const offsetPosition = Math.floor(timelineGroup.getBoundingClientRect().top + window.scrollY - navBarHeight - mainPageHeaderHeight);
                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth'
                });
            }
        }
    }

    updateActiveNav() {
        const sections = document.querySelectorAll('div[id^="tab-"]');
        const mainPageHeaderHeight = 97; // use 0 for module, use 97 for template
        const navBarHeight = this.dom.$navBar ? this.dom.$navBar.offsetHeight : 0;
        const scrollPosition = window.scrollY;
        let activeSection = 'tab-0-panel';

        if (scrollPosition === 0) {
            activeSection = 'tab-0-panel';
        } else {
            sections.forEach(section => {
                const sectionTop = section.getBoundingClientRect().top + window.scrollY - navBarHeight - mainPageHeaderHeight;
                if (scrollPosition >= sectionTop - 1) {
                    activeSection = section.getAttribute('id');
                }
            });
        }

        this.dom.$tabs.forEach($tab => {
            $tab.setAttribute('aria-selected', 'false');
            if ($tab.getAttribute('aria-controls').includes(activeSection)) {
                $tab.setAttribute('aria-selected', 'true');
            };
        });

        const selectInput = document.querySelector('.tabbed-content__dropdown-wrapper select');
        if (selectInput) {
            selectInput.value = activeSection;
        }

        // ---------------------
        // the following JS is for getting the timeline's
        // nav to be sticky under the homepage masthead
        // module in Optimizely

        const navElement = document.querySelector('.tabbed-content__tabs-wrapper');
        const header = document.querySelector('.header__wrapper');
        const timelineComponent = document.querySelector('.timeline-component');

        const headerHeight = header.offsetHeight;
        const timelineComponentHeight = timelineComponent.offsetHeight;
        const navElementHeight = navElement.offsetHeight;

        const componentsAboveTimeline = this.prevAll(timelineComponent);
        let componentsAboveTimelineHeight = 0;

        for (let x=0; x < componentsAboveTimeline.length; x++) {
            componentsAboveTimelineHeight += componentsAboveTimeline[x].offsetHeight;
        }

        const totalHeightWithoutTimeline = headerHeight + componentsAboveTimelineHeight - navElementHeight;
        const totalHeightWithTimeline = totalHeightWithoutTimeline + timelineComponentHeight - navElementHeight + 10; // adding the magic value 10 helps reduce nav flickering

        if (window.scrollY >= totalHeightWithTimeline) {
            navElement.classList.remove('fixed');
        } else if (window.scrollY >= totalHeightWithoutTimeline) {
            navElement.classList.add('fixed');
        } else {
            navElement.classList.remove('fixed');
        }
    }

    prevAll(element) {
        // eslint-disable-next-line
        let result = [];

        // eslint-disable-next-line
        while (element = element.previousElementSibling) {
            result.push(element);
        }
        return result;
    }

    debounce(func, wait) {
        let timeout;
        // eslint-disable-next-line func-names
        return function(...args) {
            const later = () => {
                clearTimeout(timeout);
                func.apply(this, args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    }
}

export default Module;
